import $ from 'jquery';

$('body').append('<div id="snippets-modal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered modal-lg"><div class="modal-content"><div class="card-body border-2 p-2 overflow-auto" style="max-height: 80vh"><ul class="list-group"></ul></div></div></div></div>');
const modalElm = $('#snippets-modal');
const modal = new bootstrap.Modal(modalElm);

function openSnippetsModal(targetEl, category, language) {
    const url = new URL(window.location.origin + '/admin/snippets/list');
    url.searchParams.append('category', category);
    if (language) {
        url.searchParams.append('language', language);
    }

    fetch(url, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
        .then((response) => {
            if (!response.ok) {
                response.json().then((data) => alert(data.error));
                return "";
            }

            return response.json();
        })
        .then((response) => addSnippetContent(targetEl, response))
}
function nl2br (str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

function escapeHtml(str) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    return (str + '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function addSnippetContent(targetEl, response) {
    // Backward compatibility: response can be array of strings (old API) or
    // array of objects {id, name, content, is_default} (new API).
    const html = response.map(function (snippet, index) {
        const isObject = snippet !== null && typeof snippet === 'object';
        const content = isObject ? (snippet.content ?? '') : snippet;
        const rawName = isObject ? (snippet.name ?? '') : '';
        const isDefault = isObject ? !!snippet.is_default : false;

        const displayName = rawName && rawName.length > 0 ? rawName : `Text ${index + 1}`;

        let preview = content;
        if (preview && preview.length > 220) {
            preview = preview.slice(0, 220) + '...';
        }

        const defaultBadge = isDefault
            ? ' <span class="badge bg-label-success ms-1">Standard</span>'
            : '';

        const encodedContent = escapeHtml(content);

        return '<li class="list-group-item cursor-pointer" data-content="' + encodedContent + '">'
            + '<div class="fw-semibold mb-1">' + escapeHtml(displayName) + defaultBadge + '</div>'
            + '<div class="small text-muted">' + nl2br(escapeHtml(preview)) + '</div>'
            + '</li>';
    }).join('');

    showSnippets(targetEl, html)
}

function showSnippets(targetEl, html) {
    modalElm.find('.modal-content ul')
        .html(html)
        .find('li')
        .click((evt) => {
            const li = evt.currentTarget;
            // dataset.content is already decoded HTML entities back to original characters
            targetEl.val(li.dataset.content)
                .get(0).dispatchEvent(new Event('input'));

            toggleModal();
        });

    toggleModal();
}

const toggleModal = () => {
    modal.toggle('show');
}

$(document).on('click', '[data-bs-snippets]', function () {
    const targetEl = $(this.attributes['data-bs-target'].value);
    const category = this.attributes['data-bs-snippets'].value;
    const language = this.attributes['data-bs-lang'] ? this.attributes['data-bs-lang'].value : null;

    openSnippetsModal(targetEl, category, language);
});
